/**
 * Experiment to migrate logged-in brand page to React Query architecture
 */
export const LIBP_REACT_QUERY_MIGRATION_240730 = 'LIBP_REACT_QUERY_MIGRATION_240730';
